/**
 * Story 052 — TanStack Query keys for the Settings feature.
 */
export const accountKeys = {
  all: ["account"] as const,
  me: () => [...accountKeys.all, "me"] as const,
  sessions: () => [...accountKeys.all, "sessions"] as const,
  mfaFactors: () => [...accountKeys.all, "mfa-factors"] as const,
};
